import type { ReactNode } from "react";
import { ClawInstallFooter } from "./ClawInstallFooter.tsx";
import { ClawInstallHeader } from "./ClawInstallHeader.tsx";

/**
 * Shared chrome for the ClawInstall marketing pages: the sticky themed header
 * (with the light/dark toggle) and the footer, wrapping each page's content.
 * Kept out of the layout route so it doesn't apply to the admin app, which
 * shares that route.
 *
 * The wrapper carries `.theme-clawinstall-customer`, so the shell-hosted pages
 * (legal, login, 404, cookie banner) render on the customer palette (DM Sans body,
 * coral/blue accents, paper/ice surfaces) with every shadcn token utility resolving.
 *
 * @since 1.0.0
 */
export function ClawInstallMarketingShell({ children }: { readonly children: ReactNode }) {
  return (
    <div className="theme-clawinstall-customer flex min-h-full flex-1 flex-col bg-surface font-sans text-on-surface">
      <ClawInstallHeader />
      {children}
      <ClawInstallFooter />
    </div>
  );
}
